import { render, staticRenderFns } from "./WriteSecretDefaultInfoForm.vue?vue&type=template&id=2a2485f2&scoped=true&"
import script from "./WriteSecretDefaultInfoForm.vue?vue&type=script&lang=js&"
export * from "./WriteSecretDefaultInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./WriteSecretDefaultInfoForm.vue?vue&type=style&index=0&id=2a2485f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2485f2",
  null
  
)

export default component.exports